import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export let db;
export let auth;

export async function initializeFirebase() {
  const response = await fetch('https://getfirebasekey-6c7wpmtlnq-uc.a.run.app');
  const { apiKey } = await response.json();

  const firebaseConfig = {
    apiKey,
    authDomain: "home-budget-9c932.firebaseapp.com",
    projectId: "home-budget-9c932",
    storageBucket: "home-budget-9c932.firebasestorage.app",
    messagingSenderId: "479359866133",
    appId: "1:479359866133:web:0776b6513dfb98eef3451c",
    measurementId: "G-PN3FSVTCL5"
  };

  const app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);
}
